class ChangeTeacherPasswordController {
    // @ngInject
    constructor(targetUser, $stateParams) {
        this.targetUser = targetUser;
        this.$stateParams = $stateParams;
    }
}

export default ChangeTeacherPasswordController;
